/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { BodyJobsetApproval, TasksApi } from "client";
import { Const } from "const";
import { useApiWithTimeout } from "./ApiWrapperWithTimeout";
import { useWaitTaskStatus } from "./WaitTaskStatusHook";
import { useCallback } from "react";

export const useApproveTask = () => {
  const [api, cancelApprove] = useApiWithTimeout(
    TasksApi,
    Const.operationTimeout.approveTask
  );
  const waitTaskStatus = useWaitTaskStatus();

  const requestApprove = useCallback(
    async (request: BodyJobsetApproval) => {
      // Approve request
      await api.approveTask({ bodyJobsetApproval: [request] });

      await waitTaskStatus(
        request.jobSetId,
        request.jobSetApproval
          ? [Const.jobsetStatus.created]
          : [Const.jobsetStatus.creationFailed],
        Const.operationTimeout.changeApproved
      );
    },
    [api, waitTaskStatus]
  );

  return { requestApprove, cancelApprove };
};
